const Button = {
  baseStyle: {},
  variants: {
    main: {
      bgColor: "main",
      fontSize: "14px",
      lineHeight: "20px",
      boxShadow: "0px 1px 2px 0px #0000000D",
      borderRadius: "6px",
      h: "38px",
      _hover: {
        bgColor: "gradient",
      },
    },
    secondary: {
      bgColor: "lightGray",
      color: "white",
      fontSize: "14px",
      lineHeight: "20px",
      boxShadow: "0px 1px 2px 0px #0000000D",
      borderRadius: "6px",
      h: "38px",
      _hover: {
        bgColor: "#d3d3d3",
      },
    },
    link: {
      color: "black",
      fontSize: "12px",
      lineHeight: "14.5px",
      fontWeight: 500,
    },
    white: {
      color: "black",
      fontSize: "12px",
      lineHeight: "14.5px",
      fontWeight: 500,
      bgColor: "white",
      borderRadius: "4px",
      borderWidth: "1px",
      borderColor: "darkBlue",
      h: "32px",
      p: "8.5px 10px",
      _hover: {
        bgColor: "gray.100",
      },
    },
  },
  // sizes: {
  //   md: {
  //     height: "38px",
  //     fontSize: "14px",
  //     lineHeight: "20px",
  //   },
  // },
};

export default Button;
